import { createFileRoute } from "@tanstack/react-router";
import { KeywordServiceLanding } from "@/components/KeywordServiceLanding";
import { KEYWORD_SERVICE_PAGES, keywordServiceHead } from "@/lib/keywordServicePages";

export const Route = createFileRoute("/crm-setup-colorado")({
  head: () => keywordServiceHead(KEYWORD_SERVICE_PAGES.crmSetup),
  component: () => <KeywordServiceLanding page={KEYWORD_SERVICE_PAGES.crmSetup} />,
});
